import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=fc09fab0&"
import script from "./FormContainer.vue?vue&type=script&lang=ts&"
export * from "./FormContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports